var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { Migration } from '@react-page/core/lib/service/plugin/classes';
// tslint:disable-next-line:no-any
var removeLeaves = function (nodes) {
    if (!nodes) {
        return [];
    }
    var cleanedNodes = nodes.reduce(function (acc, node) {
        if (node.leaves) {
            // we don't need the node itself, as we exepct it to be a text node
            return __spreadArrays(acc, node.leaves.map(function (leave) { return (__assign(__assign({}, leave), { object: 'text' })); }));
        }
        else {
            var cleanedNode = node.nodes
                ? __assign(__assign({}, node), { nodes: removeLeaves(node.nodes) }) : node;
            return __spreadArrays(acc, [cleanedNode]);
        }
    }, []);
    return cleanedNodes;
};
var migration = new Migration({
    toVersion: '0.0.3',
    fromVersionRange: '^0.0.2',
    migrate: function (state) {
        if (!state) {
            return {};
        }
        var newState = state.serialized && state.serialized.document
            ? __assign(__assign({}, state), { serialized: __assign(__assign({}, state.serialized), { document: __assign(__assign({}, state.serialized.document), { nodes: removeLeaves(state.serialized.document.nodes) }) }) }) : state;
        return newState;
    },
});
export default migration;
//# sourceMappingURL=v003.js.map